module.exports = __webpack_public_path__ + "img/140.dbfbbcc8.jpg";